/* Dim Nook — drawer cart. Hydrates from /cart.js; qty via /cart/change.js.
   Opens on: header cart link, dn:cart:added event (from dn-product.js).
   The /cart page stays as the no-JS fallback. */
(function () {
  'use strict';
  var root = document.getElementById('dn-drawer');
  if (!root) return;
  var threshold = parseInt(root.dataset.threshold, 10) || 0;
  var linesEl = root.querySelector('[data-drawer-lines]');
  var busy = false;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function render(cart) {
    root.querySelector('[data-drawer-count]').textContent = '— ' + cart.item_count;
    document.querySelectorAll('[data-dn-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var empty = cart.item_count === 0;
    root.querySelector('[data-drawer-empty]').hidden = !empty;
    root.querySelector('[data-drawer-foot]').hidden = empty;
    var ship = root.querySelector('[data-drawer-ship]');
    ship.hidden = empty || !threshold;
    if (!ship.hidden) {
      var txt = root.querySelector('[data-drawer-ship-text]');
      var fill = root.querySelector('[data-drawer-ship-fill]');
      if (cart.total_price >= threshold) {
        txt.innerHTML = '<b>Free U.S. shipping unlocked ✓</b>';
        fill.style.width = '100%';
        ship.classList.add('unlocked');
      } else {
        txt.innerHTML = '<b>' + money(threshold - cart.total_price) + '</b> away from free U.S. shipping';
        fill.style.width = Math.round(cart.total_price * 100 / threshold) + '%';
        ship.classList.remove('unlocked');
      }
    }
    linesEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'dn-drawer-line';
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">' : '';
      row.innerHTML = img +
        '<div class="mid"><b>' + item.product_title.split('—')[0].trim() + '</b>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + item.variant_title + '</small>' : '') +
        '<div class="qty" data-key="' + item.key + '">' +
        '<button type="button" data-q="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-q="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '<button type="button" class="rm" data-q="0">Remove</button>' +
        '</div></div>' +
        '<span class="lp">' + money(item.final_line_price) + '</span>';
      linesEl.appendChild(row);
    });
    root.querySelector('[data-drawer-subtotal]').textContent = money(cart.total_price);
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    /* open immediately; hydrate after. If the cart API is unreachable,
       fall back to the full /cart page rather than a dead drawer. */
    root.classList.add('open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var x = root.querySelector('.dn-drawer-x');
    if (x) x.focus();
    refresh().catch(function () {
      close();
      window.location.href = '/cart';
    });
  }
  function close() {
    root.classList.remove('open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { close(); return; }
    var qbtn = e.target.closest('.qty button');
    if (qbtn && !busy) {
      busy = true;
      var key = qbtn.closest('.qty').dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(qbtn.dataset.q, 10) })
      }).then(function (r) { return r.json(); }).then(function (cart) { busy = false; render(cart); })
        .catch(function () { busy = false; refresh().catch(function () {}); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* header cart link opens the drawer everywhere */
  document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach(function (a) {
    if (a.closest('#dn-drawer')) return; /* keep "view full cart" a real link */
    a.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  /* after add-to-cart */
  document.addEventListener('dn:cart:added', open);
})();
